import {
  Alignment,
  PopoverInteractionKind,
  Spinner,
  Switch,
  Tag,
  Tooltip,
} from '@blueprintjs/core';
import { useContext } from 'react';
import styles from './PortfolioNavigation.module.css';
import { useIsManager } from '@axo/shared/data-access/provider';
import { RecieveApplicationsTooltip } from './RecieveApplicationsTooltip';
import { NewApplicationsTooltip } from './NewApplicationsTooltip';
import {
  MAX_NUMBER_OF_ASSIGNMENTS,
  UnprocessedTooltipManager,
} from './UnprocessedTooltipManager';
import { UnprocessedTooltipUser } from './UnprocessedTooltipUser';
import { classNames } from '@axo/shared/util/dom';
import { HeartbeatContext } from '../HeartbeatProvider';
import { useAgentAvailability } from '../../hooks/utils/useAgentAvailability';

export function PortfolioNavigation({
  marketCountry,
}: {
  marketCountry: string;
}) {
  const {
    isAvailable,
    toggleAvailability,
    isToggleLoading,
    portfolioStats,
    version,
  } = useAgentAvailability({ marketCountry });

  const { isActive } = useContext(HeartbeatContext);

  const newApplicationsTagClass = () => {
    const numAssignments = portfolioStats?.assignedApplicationCount ?? 0;
    if (numAssignments === 0) return styles.newApplicationsTagNone;
    if (numAssignments >= MAX_NUMBER_OF_ASSIGNMENTS) {
      return classNames(
        styles.newApplicationsTagFull,
        styles.animateThisElement
      );
    }

    return classNames(
      styles.newApplicationsTagMedium,
      styles.animateThisElement
    );
  };

  const isManager = useIsManager();

  return (
    <div className={styles.container}>
      <Tooltip
        interactionKind={PopoverInteractionKind.HOVER}
        content={
          <RecieveApplicationsTooltip recieveApplications={isAvailable} />
        }
        placement="bottom"
        hoverCloseDelay={200}
      >
        <Switch
          checked={isAvailable}
          onChange={toggleAvailability}
          className={styles.switch}
          alignIndicator={Alignment.END}
          disabled={!isActive || isToggleLoading}
        />
      </Tooltip>
      {portfolioStats && (
        <Tooltip
          interactionKind={PopoverInteractionKind.HOVER}
          content={<NewApplicationsTooltip />}
          placement="bottom"
          hoverCloseDelay={200}
        >
          <Tag
            className={newApplicationsTagClass()}
            data-testid="new-applications-tag"
          >
            {portfolioStats.assignedApplicationCount}
          </Tag>
        </Tooltip>
      )}
      {portfolioStats && version !== 'v3' && (
        <Tooltip
          interactionKind={PopoverInteractionKind.HOVER}
          content={
            isManager ? (
              portfolioStats.unprocessedStats ? (
                <UnprocessedTooltipManager
                  marketCountry={marketCountry}
                  unprocessedStats={portfolioStats.unprocessedStats}
                />
              ) : (
                <Spinner />
              )
            ) : (
              <UnprocessedTooltipUser />
            )
          }
          placement="bottom"
          hoverCloseDelay={200}
        >
          <Tag
            round
            minimal
            intent={
              portfolioStats.unprocessedStats?.NumQueue === 0
                ? 'none'
                : 'danger'
            }
            data-testid="user-tag"
          >
            {portfolioStats.unprocessedStats?.NumQueue}
          </Tag>
        </Tooltip>
      )}
    </div>
  );
}
